// extracted by mini-css-extract-plugin
export default {"modalButton":"address_modalButton__gGNZ6","checkbox":"address_checkbox__vijFo"};